import { useEffect, useState } from "react";
import IconLoadingWave from "../../../icons/IconLoadingWave";
import List from "../../../components/List";
import {
  apiOnlineMenuUrl,
  clientOnlineMenuUrl,
  executeRequest,
  getApplicationToken,
} from "../../../functions/requests";
import { useNavigate } from "react-router-dom";
import Spacer from "../../../components/Spacer";
import Button from "../../../components/Button";
import FormInput from "../../../components/FormInput";
import Message from "../../../components/Message";

export default function OnlineMenuSettings() {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [menuSettings, setMenuSettings] = useState([]);
  const [menuSettingToEdit, setMenuSettingToEdit] = useState(null);
  // Message popup
  const [message, setMessage] = useState("");
  const [messageSection, setMessageSection] = useState("");

  // Close message
  const messageClose = () => {
    setMessage("");
    setMessageSection("");
  };

  // Get all menu settings for the current user
  const getMenuSettings = async () => {
    await executeRequest(
      `${apiOnlineMenuUrl}menu-settings`,
      "GET",
      null,
      {
        Authorization: "Bearer " + getApplicationToken("online_menu"),
      },
      async (data) => {
        console.log(data);
        setMenuSettings(data);
        setLoading(false);
      },
      (error) => {
        console.log(error);
      }
    );
  };

  // Update a single menu setting
  const updateMenuSetting = async () => {
    setLoading(true);
    var finalFields = new FormData();
    var originalMenuSetting = menuSettings.find(
      (setting) => setting.uuid === menuSettingToEdit.uuid
    );

    // Check which fields have changed
    for (let key in menuSettingToEdit) {
      if (
        key === "title" ||
        key === "logo" ||
        key === "main_image" ||
        key === "email" ||
        key === "phone" ||
        key === "main_language_uuid" ||
        key === "facebook_url" ||
        key === "instagram_url" ||
        key === "tiktok_url" ||
        key === "linkedin_url" ||
        key === "twitter_url"
      ) {
        // Pass properties that are common
        if (
          menuSettingToEdit.hasOwnProperty(key) &&
          originalMenuSetting.hasOwnProperty(key)
        ) {
          if (menuSettingToEdit[key] !== originalMenuSetting[key]) {
            finalFields.append([key], menuSettingToEdit[key]);
          }
        } else {
          // Pass properties that do not exist in the original item
          finalFields.append([key], menuSettingToEdit[key]);
        }
      }
    }

    await executeRequest(
      `${apiOnlineMenuUrl}menu-settings/${menuSettingToEdit.uuid}`,
      "POST",
      finalFields,
      {
        Authorization: "Bearer " + getApplicationToken("online_menu"),
      },
      async (data) => {
        console.log(data);
        setMessageSection("updateItem");
        setMessage("Menu setting successfully updated.");
        setMenuSettingToEdit(null);
        getMenuSettings();
      },
      (error) => {
        console.log(error);
      }
    );
    setLoading(false);
  };

  // Get menu settings initially
  useEffect(() => {
    getMenuSettings();
  }, []);

  if (menuSettingToEdit === null) {
    return (
      <>
        <h1 className="page-title">My Menu Setups</h1>
        <Button
          text="< Back to profile"
          type="underlined"
          onClicked={() => {
            navigate("/projects/online-menu");
          }}
        />
        <Spacer />
        {loading ? (
          <IconLoadingWave />
        ) : menuSettings.length < 1 ? (
          <div>No menu setups created yet.</div>
        ) : (
          <List
            headers={[
              "Title",
              "Logo",
              "Main image",
              "Contact info",
              "Social links",
              "Main language",
            ]}
            itemType="menu-settings"
            items={menuSettings}
            isLoading={loading}
            onView={(item) =>
              navigate("/projects/online-menu/menu-settings/" + item.uuid)
            }
            onEdit={(item) => setMenuSettingToEdit(item)}
          />
        )}
      </>
    );
  }

  return (
    <>
      <h1 className="page-title">Edit {menuSettingToEdit.title}</h1>
      <Button
        text="< Back"
        type="underlined"
        onClicked={() => setMenuSettingToEdit(null)}
      />
      <Spacer />
      <h2>Branding</h2>
      <Spacer />
      <FormInput
        type="text"
        value={menuSettingToEdit.title}
        title="Title"
        onChanged={(value) => {
          setMenuSettingToEdit({
            ...menuSettingToEdit,
            title: value,
          });
        }}
      />
      <Spacer />
      <FormInput
        type="image"
        selectedImageUrl={clientOnlineMenuUrl + menuSettingToEdit.logo_url}
        title="Logo"
        onChanged={(value) => {
          console.log(value);
          setMenuSettingToEdit({
            ...menuSettingToEdit,
            logo: value,
          });
        }}
      />
      <Spacer />
      <FormInput
        type="image"
        selectedImageUrl={
          clientOnlineMenuUrl + menuSettingToEdit.main_image_url
        }
        title="Main image"
        onChanged={(value) => {
          console.log(value);
          setMenuSettingToEdit({
            ...menuSettingToEdit,
            main_image: value,
          });
        }}
      />
      <Spacer />
      <h2>Contact info</h2>
      <Spacer />
      <FormInput
        type="email"
        title="Email"
        value={menuSettingToEdit.email}
        onChanged={(value) => {
          console.log(value);
          setMenuSettingToEdit({
            ...menuSettingToEdit,
            email: value,
          });
        }}
      />
      <Spacer />
      <FormInput
        type="number"
        title="Phone"
        value={menuSettingToEdit.phone}
        onChanged={(value) => {
          console.log(value);
          setMenuSettingToEdit({
            ...menuSettingToEdit,
            phone: value,
          });
        }}
      />
      <Spacer />
      <h2>Social links</h2>
      <Spacer />
      <FormInput
        type="text"
        title="Facebook URL"
        value={menuSettingToEdit.facebook_url}
        onChanged={(value) => {
          console.log(value);
          setMenuSettingToEdit({
            ...menuSettingToEdit,
            facebook_url: value,
          });
        }}
      />
      <Spacer />
      <FormInput
        type="text"
        title="Instagram URL"
        value={menuSettingToEdit.instagram_url}
        onChanged={(value) => {
          console.log(value);
          setMenuSettingToEdit({
            ...menuSettingToEdit,
            instagram_url: value,
          });
        }}
      />
      <Spacer />
      <FormInput
        type="text"
        title="TikTok URL"
        value={menuSettingToEdit.tiktok_url}
        onChanged={(value) => {
          console.log(value);
          setMenuSettingToEdit({
            ...menuSettingToEdit,
            tiktok_url: value,
          });
        }}
      />
      <Spacer />
      <FormInput
        type="text"
        title="LinkedIn URL"
        value={menuSettingToEdit.linkedin_url}
        onChanged={(value) => {
          console.log(value);
          setMenuSettingToEdit({
            ...menuSettingToEdit,
            linkedin_url: value,
          });
        }}
      />
      <Spacer />
      <FormInput
        type="text"
        title="Twitter URL"
        value={menuSettingToEdit.twitter_url}
        onChanged={(value) => {
          console.log(value);
          setMenuSettingToEdit({
            ...menuSettingToEdit,
            twitter_url: value,
          });
        }}
      />
      <Spacer />
      <h2>Main language</h2>
      <Spacer />
      <FormInput
        type="select"
        title="Choose one of the available languages"
        selectOptions={menuSettingToEdit.languages}
        value={menuSettingToEdit.main_language_uuid}
        onChanged={(value) => {
          console.log(value);
          setMenuSettingToEdit({
            ...menuSettingToEdit,
            main_language_uuid: value,
          });
        }}
      />
      <Spacer />
      <Button
        text="Update"
        disabled={menuSettings}
        isLoading={loading}
        onClicked={() => updateMenuSetting()}
      />
      {(messageSection === "addNewItem" ||
        messageSection === "updateItem" ||
        messageSection === "deleteItem") && (
        <Message
          type="success"
          isInline={false}
          message={message}
          onClosed={() => messageClose()}
        />
      )}
      {(messageSection === "addNewItemError" ||
        messageSection === "updateItemError" ||
        messageSection === "deleteItemError") && (
        <Message
          type="error"
          isInline={false}
          message={message}
          onClosed={() => messageClose()}
        />
      )}
    </>
  );
}
